import { GraphQLClient, type TypedDocumentString } from 'graphql-request';
import { csrfHeaders } from './csrf';

const client = new GraphQLClient(window.location.origin + '/graphql', {
  credentials: 'include',
});

export function graphqlRequest<T, V>(
  document: TypedDocumentString<T, V>,
  variables?: object
): Promise<T> {
  client.setHeaders(csrfHeaders());
  return client.request<T>(document, variables);
}
